import React from "react";
import { Form } from "react-bootstrap";
import { FaTrashAlt } from "react-icons/fa";

export default function ProfileAddresses(props) {
  const {
    addresses,
    selectedSavedAddressIndex,
    setSelectedSavedAddressIndex,
    setUpdateAddress,
    setAddressUpdateType,
  } = props;

  return (
    <div className="d-flex justify-content-around align-items-center flex-wrap">
      {addresses.map((element, index) => (
        <div className="d-flex mt-1 mb-1">
          <Form.Check
            type="radio"
            label={element.addressName || `Address${index + 1}`}
            name="address"
            id="address"
            checked={index === selectedSavedAddressIndex}
            onClick={() => setSelectedSavedAddressIndex(index)}
          />
          <FaTrashAlt
            className="ml-2"
            size={20}
            onClick={() => {
              setUpdateAddress(element);
              setAddressUpdateType(0);
            }}
          />
        </div>
      ))}
    </div>
  );
}
